/**
 * Les pays vers lesquels on expédie réellement.
 *
 * Décision du 14/08/2026 : on se limite à la zone proche — Benelux, France,
 * Allemagne, Espagne. L'Italie (20,06 €) et le Portugal (23,93 €) coûtaient
 * plus cher en transport que la marge dégagée sur le jeu : mieux vaut ne pas
 * les proposer que de les proposer à perte, ou de facturer un port qui fait
 * fuir. Tarifs réels mesurés au départ de la Belgique pour un colis de 0,6 kg :
 *
 *   Luxembourg 3,77 €  ·  Belgique 3,89 €  ·  Pays-Bas 4,36 €
 *   Allemagne  8,92 €  ·  France   9,04 €  ·  Espagne  10,96 €
 *
 * Cette liste est la SEULE source : le tunnel de commande et le formulaire de
 * profil la lisent tous les deux. Les deux menus étaient auparavant écrits en
 * dur, chacun de son côté, et pouvaient diverger sans que rien ne le signale.
 *
 * Pour rouvrir un pays : l'ajouter ici, vérifier qu'un transporteur le couvre
 * (GET /api/shipping-rates) et compléter les délais dans les CGV.
 */
export const PAYS_LIVRES = ['FR', 'BE', 'LU', 'NL', 'DE', 'ES'];

/**
 * Noms en français, pour les écrans qui ne passent pas par i18n (le formulaire
 * de profil, derrière le compte client). Le tunnel de commande, lui, utilise
 * les clés `tunnel.checkout.pays<CODE>` et suit donc la langue du visiteur.
 */
export const NOMS_PAYS = {
  FR: 'France',
  BE: 'Belgique',
  LU: 'Luxembourg',
  NL: 'Pays-Bas',
  DE: 'Allemagne',
  ES: 'Espagne',
};

/**
 * Noms de pays acceptés en entrée, ramenés à leur code ISO.
 *
 * Sendcloud ne connaît QUE le code à deux lettres en majuscules : « be »,
 * « Belgique » ou « Belgium » lui font répondre zéro transporteur, et l'écran
 * affichait alors « livraison temporairement indisponible vers ce pays » — un
 * message faux, sur un pays desservi. Une valeur non normalisée peut arriver de
 * l'autofill du navigateur, d'un profil client rempli avant que le menu déroulant
 * n'existe, ou d'un import. On la ramène ici plutôt que de la refuser.
 *
 * Sans accents et en minuscules : c'est la forme sur laquelle on compare.
 */
const CODES_PAR_NOM = {
  france: 'FR',
  frankrijk: 'FR',
  frankreich: 'FR',
  francia: 'FR',
  belgique: 'BE',
  belgie: 'BE',
  belgien: 'BE',
  belgium: 'BE',
  belgica: 'BE',
  luxembourg: 'LU',
  luxemburg: 'LU',
  luxemburgo: 'LU',
  letzebuerg: 'LU',
  'pays-bas': 'NL',
  'pays bas': 'NL',
  nederland: 'NL',
  netherlands: 'NL',
  niederlande: 'NL',
  'paises bajos': 'NL',
  hollande: 'NL',
  holland: 'NL',
  allemagne: 'DE',
  deutschland: 'DE',
  germany: 'DE',
  duitsland: 'DE',
  alemania: 'DE',
  espagne: 'ES',
  espana: 'ES',
  spain: 'ES',
  spanje: 'ES',
  spanien: 'ES',
};

/**
 * Ramène une saisie de pays à son code ISO à deux lettres, ou à '' si on ne
 * sait pas l'identifier. Rendre '' est volontaire : mieux vaut redemander le
 * pays que d'interroger le transporteur avec une valeur qu'il ne comprend pas.
 */
export function normaliserPays(valeur) {
  if (!valeur) return '';

  const brut = String(valeur).trim();
  const majuscules = brut.toUpperCase();
  if (PAYS_LIVRES.includes(majuscules)) return majuscules;

  const aplati = brut
    .normalize('NFD')
    .replace(new RegExp('[\u0300-\u036f]', 'g'), '')
    .toLowerCase()
    .replace(/\s+/g, ' ');

  return CODES_PAR_NOM[aplati] || '';
}

/** Livre-t-on vers ce pays ? */
export const estLivrable = (code) => PAYS_LIVRES.includes(normaliserPays(code));
